module.exports = __webpack_public_path__ + "img/partical-capacitor.9a67678d.png";